import React from 'react';

import { cn } from '@/lib/utils';

interface RightPanelSlotProps {
  width: number;
  className?: string;
  children: React.ReactNode;
}

/**
 * The floating right-hand slot. Its occupants — the inspector and the node
 * library — are mutually exclusive, so they share one geometry: inset from the
 * right edge and below the action cluster, with the canvas running underneath.
 * It stops above the bottom-right corner button rather than running behind it,
 * so that button stays reachable while a panel is open.
 */
export const RightPanelSlot: React.FC<RightPanelSlotProps> = ({
  width,
  className,
  children,
}) => (
  <div
    className={cn('absolute top-14 right-2 bottom-18 z-40', className)}
    style={{ width }}
  >
    {children}
  </div>
);

/** The card every occupant of the slot is drawn on. */
export const rightPanelCardClasses =
  'flex flex-col overflow-hidden rounded-xl border border-border bg-sidebar shadow-sm';
